{
  "id": "icons-ui",
  "class": "icon",
  "size": {
    "w": 16,
    "h": 16
  },
  "anchor": {
    "x": 8,
    "y": 8
  },
  "palette": {
    "k": "#23140b",
    "g": "#6a9a3f",
    "G": "#97c25a",
    "e": "#46702f",
    "r": "#a82c2c",
    "R": "#cf4a4a",
    "D": "#731c1c",
    "n": "#d6d0c6",
    "N": "#aaa399",
    "E": "#7a736b",
    "W": "#f5f1e8",
    "y": "#e6b832",
    "Y": "#f7d969",
    "d": "#be7934",
    "p": "#d9687e",
    "P": "#ad4459",
    "c": "#dcc096",
    "C": "#efe0c2",
    "b": "#4a78b0",
    "B": "#7aa8d8",
    "u": "#2c4a7a"
  },
  "frames": {
    "check": [
      "................",
      "............kk..",
      "...........kGGk.",
      "..........kGGgk.",
      ".........kGGgekk",
      "........kGGgekk.",
      "..kk...kGGgekk..",
      ".kGGk.kGGgekk...",
      ".kGGkkGggekk....",
      "..kGGgggekk.....",
      "...kgggekk......",
      "....kgekk.......",
      ".....kkk........",
      "................",
      "................",
      "................"
    ],
    "close": [
      "................",
      "..kkk......kkk..",
      ".kRRRk....kRRRk.",
      ".kRRrrk..krrDkk.",
      "..kRrrkkkrrDk...",
      "...kRrrrrrDk....",
      "....krrrrDk.....",
      "...kRrrrrrDk....",
      "..kRrrkkkrrDk...",
      ".kRRrrk..krrDkk.",
      ".kRRRk....kRRRk.",
      "..kkk......kkk..",
      "................",
      "................",
      "................",
      "................"
    ],
    "back": [
      "................",
      "................",
      "......kk........",
      ".....kNNk.......",
      "....kNNNkkkkkkk.",
      "...kNNNNNNNNNNNk",
      "..kNNNNNNNNNNNNk",
      ".kNNnnnNNNEEEEkk",
      "..kNNNNNNNNNNNNk",
      "...kNNNNNNNNNNNk",
      "....kNNNkkkkkkk.",
      ".....kNNk.......",
      "......kk........",
      "................",
      "................",
      "................"
    ],
    "prev": [
      "................",
      ".......kk.......",
      "......kNNk......",
      ".....kNNNkk.....",
      "....kNNNnnk.....",
      "...kNNNnnk......",
      "..kNNNnnk.......",
      "..kNNNnnk.......",
      "...kNNNnnk......",
      "....kNNNnnk.....",
      ".....kNNNkk.....",
      "......kNNk......",
      ".......kk.......",
      "................",
      "................",
      "................"
    ],
    "next": [
      "................",
      ".......kk.......",
      "......kNNk......",
      ".....kkNNNk.....",
      ".....knnNNNk....",
      "......knnNNNk...",
      ".......knnNNNk..",
      ".......knnNNNk..",
      "......knnNNNk...",
      ".....knnNNNk....",
      ".....kkNNNk.....",
      "......kNNk......",
      ".......kk.......",
      "................",
      "................",
      "................"
    ],
    "lock": [
      "................",
      "......kkkk......",
      ".....kNNNNk.....",
      "....kNNkkNNk....",
      "....kNNkkNNk....",
      "...kkkkkkkkkk...",
      "..kYYYYYYYYYYk..",
      "..kYYYyyyggddk..",
      "..kYYyykkygddk..",
      "..kYYyykkygddk..",
      "..kYYyyyyygddk..",
      "..kYyggggggddk..",
      "..kkkkkkkkkkkk..",
      "................",
      "................",
      "................"
    ],
    "warning": [
      "................",
      ".......kk.......",
      "......kYYk......",
      ".....kYYYYk.....",
      "....kYYkkYYk....",
      "....kYYkkYYk....",
      "...kYYYkkYYyk...",
      "..kYYYYkkYYyyk..",
      "..kYYYYYYYYyyk..",
      ".kYYYYYkkYYyyyk.",
      ".kYYYYYkkYYyyyk.",
      "kYYYYYYYYYYYYYyk",
      "kkkkkkkkkkkkkkkk",
      "................",
      "................",
      "................"
    ],
    "shell": [
      "................",
      "......kkkk......",
      "....kkppppkk....",
      "...kppppppppk...",
      "..kppppppppppk..",
      "..kppppppppppk..",
      ".kppppppppppppk.",
      ".kCCCCCCCCCCCCk.",
      ".kcccccccccccck.",
      "..kppppppppppk..",
      "..kppppppppppk..",
      "...kPPPPPPPPk...",
      "....kkPPPPkk....",
      "......kkkk......",
      "................",
      "................"
    ],
    "water": [
      "................",
      "................",
      ".......kk.......",
      "......kBBk......",
      ".....kBBbbk.....",
      "....kBBbbbbk....",
      "...kBBbbbbbbk...",
      "..kBBbbbbbbbuk..",
      "..kBbbbbbbbbuuk.",
      "..kbbbbbbbbbuuk.",
      "..kbbbbbbbbbuuk.",
      "...kbbbbbbbuuk..",
      "....kbuuuuuuk...",
      ".....kkkkkkk....",
      "................",
      "................"
    ],
    "meter-ok": [
      "................",
      "................",
      "................",
      "..........kk....",
      ".........kGGk...",
      "........kGgek...",
      "........kGgek...",
      "..kk...kGgek....",
      ".kGGk.kGgek.....",
      "..kGGkGgek......",
      "...kGGgek.......",
      "....kgek........",
      ".....kk.........",
      "................",
      "................",
      "................"
    ],
    "meter-warn": [
      "................",
      "................",
      ".......kk.......",
      "......kYYk......",
      ".....kYYYYk.....",
      "....kYYkkYYk....",
      "...kYYYkkYYyk...",
      "..kYYYYkkYYyyk..",
      "..kYYYYYYYYyyk..",
      ".kYYYYYkkYYyyyk.",
      ".kkkkkkkkkkkkkk.",
      "................",
      "................",
      "................",
      "................",
      "................"
    ],
    "meter-crit": [
      "................",
      ".......kk.......",
      "......kRRk......",
      ".....kRRrrk.....",
      "....kRRrrrrk....",
      "...kRRkkkkrrk...",
      "....kkkkkkkk....",
      ".......kk.......",
      "......kRRk......",
      ".....kRRrrk.....",
      "....kRRrrrrk....",
      "...kRRkkkkrrk...",
      "....kkk..kkk....",
      "................",
      "................",
      "................"
    ],
    "phone": [
      "................",
      ".....kkkkkk.....",
      "....kNNNNNNk....",
      "....kNNkkNNk....",
      "....kNBBBBuk....",
      "....kNBbbbuk....",
      "....kNBbbbuk....",
      "....kNBbbbuk....",
      "....kNBbbbuk....",
      "....kNbuuuuk....",
      "....kNNNNNNk....",
      "....kNNkkNNk....",
      ".....kkkkkk.....",
      "................",
      "................",
      "................"
    ]
  }
}
